import * as React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid
} from "@mui/material";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import {gql} from "@apollo/client";
import LoadingDialog from "../../components/loadingDialog";
import {mutate} from "../../lib/apollo";
import TextField from "@mui/material/TextField";
import {useNavigate} from "react-router-dom";

export default function ProgramSetUpsert (params: {programSet: any, setProgramSet: any, reload: any}) {
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const [name, setName] = React.useState('' as string);

    React.useEffect(() => {
        if (params.programSet) {
            setName(params.programSet.name || '');
        } else {
            setName('');
        }
    }, [params.programSet]);

    const handleClose = (event?: any, reason?: any) => {
        if (reason && reason == "backdropClick")
            return;
        params.setProgramSet(null);
    };

    const handleSubmit = async () => {
        if (!name.trim()) {
            toast.error('Please enter a valid Program Set Name');
            return;
        }

        const q = gql`
            mutation m($input: HpProgramSetCreateInput!) {
                hpProgramSetCreate(input: $input) {
                    id
                }
            }
        `;

        const variables = {
            input: {
                name,
            }
        };

        setLoading(true);

        const res = await mutate(q, variables);
        const good = res && res.hpProgramSetCreate && res.hpProgramSetCreate.id;

        if (good) {
            toast.success('Program Set created successfully');
            setLoading(false);
            handleClose();
            navigate(`/programSets/${res.hpProgramSetCreate.id}`);
        } else {
            setLoading(false);
        }
    }

    if (!params.programSet) return <> </>;

    return (
        <>
                <Dialog
                    open={!!params.programSet}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={'sm'}
                    fullWidth={true}
                >
                    <DialogTitle id="alert-dialog-title">
                        Create Program Set
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    autoComplete={'off'}
                                    margin="dense"
                                    id="name"
                                    label="Name"
                                    type="text"
                                    fullWidth
                                    size={'small'}
                                    value={name}
                                    inputProps={{maxLength: 50}}
                                    onChange={(e) => setName(e.target.value)}
                                    helperText="Format: SCHOOL (BROKER)"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    {loading ? <LoadingDialog/> :
                    <DialogActions>
                        <Button sx={{color: 'red'}} onClick={handleClose}>Close</Button>
                        <Button sx={{color: 'green'}} onClick={handleSubmit} autoFocus>
                            Create
                        </Button>
                    </DialogActions>
                    }
                </Dialog>
        </>
    )
}
